export default __webpack_public_path__ + "static/media/unkown-file.980dba0f.svg";